import Vue from "vue";

export const ServiceEventBus = new Vue();
